import axios from "axios";
import BaseApi from "../BaseApi";
import CertificateAPI from "../Certificate";
import { TransitionCompleteResponse } from "src/Types/Task";
import { BrowseCertificateWindowType, ChooseDocsJsonResponseType, SignInfoType } from "src/Types/ReDoc";

export type CreateAndSendResponseType = TransitionCompleteResponse | ChooseDocsJsonResponseType;

export default class GetSmevRequestApi extends BaseApi {

	/** Обработка события нажатия кнопки "Сформировать и отправить" */
	static createAndSendRequest = async ( fileId: string, componentId: string, choosenCheckbox: Array<string> ): Promise<CreateAndSendResponseType> => {
		const url = window.host + "/GetSmevRequest/CreateAndSendRequest";
		const data = { fileId, componentId, choosenCheckbox };
		try {
			const request = await axios.post( url, data, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при формировании и отправки данных задачи" );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			throw new Error("Ошибка при формировании и отправки данных задачи" );
		}
	};

	static startSign = async ( fileId: string, componentId: string, thumbprint: string ) => {
		try {
			const cert = await CertificateAPI.getCertInfoByThumbprint( thumbprint );
			const data: any = { fileId, componentId, thumbprint, certificate: cert.base64 };
			const hashResult = await this._sendGetHash( data );
			data.hashAlgId = hashResult.hashAlgId;
			data.digest = hashResult.digest;
			data.digestXml = hashResult.digestXml;
			return this._signDigests( data );
		}
		catch ( error: any ) {
			throw new Error("Ошибка при подписании!" );
		}
	};

	static _sendGetHash = async ( data: SignInfoType ): Promise<BrowseCertificateWindowType> => {
		const url = window.host + "/GetSmevRequest/GetHash";
		try {
			const request = await axios.post( url, data, { withCredentials: true });
			return request.data;
		}
		catch (error: any) {
			throw new Error("Ошибка при получении хэша для подписи" );
		}
	};

	static _signDigests = async ( data: any ) => {
		if ( !!data.digest ) {
			data.digest = (await CertificateAPI.signHash( data.digest, data.hashAlgId, data.thumbprint )).data;
			if ( !!data.digestXml ) {
				data.digestXml = await CertificateAPI.signXmlPlugin( data.thumbprint, data.digestXml );
				// Отправляем подписанные данные на сервер
				return await this._saveSignature(data);
			}
			else {
				return await this._saveSignature(data);
			}
		}
		else if ( !!data.digestXml ) {
			data.digestXml = await CertificateAPI.signXmlPlugin( data.thumbprint, data.digestXml );
			// Отправляем подписанные данные на сервер
			return await this._saveSignature(data);
		}
	};

	static _saveSignature = async ( data: SignInfoType ): Promise<TransitionCompleteResponse> => {
		const url = window.host + "/GetSmevRequest/SaveSignData";
		try {
			const request = await axios.post( url, data, { withCredentials: true });
			if ( this.checkUnauthorized( request ) ) {
				throw new Error("Ошибка при формировании и отправки данных задачи" );
			}
			else {
				return request.data;
			}
		}
		catch (error: any) {
			throw new Error("Ошибка при формировании и отправки данных задачи" );
		}
	};
};
